import { Card, Rank, compareRank, compareSuit, getRankValue } from 'game-library';
export function countDeadwood(hand, ignore11th = false) {
    const collection = getCollection(hand);
    let count = 0;
    for (const card of collection.deadwood) {
        count += getPointValue(card.rank);
    }
    //minus 11th card, the highest value card in the deadwood
    if (ignore11th && hand.length > 10) {
        let highestPointsCard = 0;
        for (const card of collection.deadwood) {
            let points = getPointValue(card.rank);
            if (highestPointsCard < points)
                highestPointsCard = points;
        }
        count -= highestPointsCard;
    }
    return count;
}
export function getPointValue(rank) {
    switch (rank) {
        case "A":
            return 1;
        case "K":
            return 10;
        case "Q":
            return 10;
        case "J":
            return 10;
        default:
            const val = parseInt(rank);
            return val;
    }
}
function findAllRuns(hand, index, runs, run = []) {
    //assumption: hand is sorted by rank and suit
    if (index >= hand.length)
        return;
    //seed the run
    if (run.length === 0) {
        run.push(hand[index]);
        findAllRuns(hand, index + 1, runs, run);
        return;
    }
    const runLastCard = run[run.length - 1];
    for (let i = index; i < hand.length; i++) {
        const nextHandCard = hand[i];
        const nextHandCardValue = getRankValue(nextHandCard.rank);
        const runLastCardValue = getRankValue(runLastCard.rank);
        if (runLastCardValue + 1 === nextHandCardValue && runLastCard.suit === nextHandCard.suit) {
            //we have a run
            const runCopy = Array.from(run);
            runCopy.push(nextHandCard);
            //add run if larger 3 or larger
            if (runCopy.length >= 3) {
                runs.push(runCopy);
            }
            //look for longer runs
            findAllRuns(hand, i + 1, runs, runCopy);
        }
        if (runLastCardValue + 1 < nextHandCardValue) {
            break;
        }
    }
}
export function getCollection(cards) {
    const handCopy = cards.map((c) => Card.fromString(c.toString())).sort(rankAndSuitSorter);
    const possibleMelds = [];
    //find all possible sets
    const ranks = Object.values(Rank);
    for (const rank of ranks) {
        const sameSuits = handCopy.filter((m) => m.rank === rank);
        if (sameSuits.length < 3)
            continue;
        if (sameSuits.length === 3) {
            possibleMelds.push(sameSuits);
        }
        if (sameSuits.length === 4) {
            //find all sets of 3 and the 1 set of 4
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[2]]);
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[3]]);
            possibleMelds.push([sameSuits[0], sameSuits[2], sameSuits[3]]);
            possibleMelds.push([sameSuits[1], sameSuits[2], sameSuits[3]]);
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[2], sameSuits[3]]);
        }
    }
    //find all possible runs
    for (let i = 0; i < handCopy.length; i++) {
        findAllRuns(handCopy, i, possibleMelds);
    }
    //find all compatible melds
    const compatibleMelds = [];
    //3 melds is the max a hand can have
    for (const meld1 of possibleMelds) {
        const cleanMelds = possibleMelds.filter((m) => m.every((c) => !meld1.includes(c)));
        if (cleanMelds.length === 0) {
            compatibleMelds.push([meld1]);
            continue;
        }
        for (const meld2 of cleanMelds) {
            const cleanMelds2 = cleanMelds.filter((m) => m.every((c) => !meld1.includes(c) && !meld2.includes(c)));
            if (cleanMelds2.length === 0) {
                compatibleMelds.push([meld1, meld2]);
                continue;
            }
            for (const meld3 of cleanMelds2) {
                compatibleMelds.push([meld1, meld2, meld3]);
            }
        }
    }
    //find the best melds
    let bestMelds = [];
    let highestPoints = 0;
    let lowestMeldCount = 5;
    for (const melds of compatibleMelds) {
        //find highest points which inversely correlates to the lowest deadwood
        //get all the cards in the melds as a single array
        const meldCards = [].concat(...melds);
        //calculate points
        const points = meldCards.reduce((acc, val) => acc + getRankValue(val.rank), 0);
        if (points > highestPoints || (points === highestPoints && melds.length < lowestMeldCount)) {
            bestMelds = melds;
            highestPoints = points;
            lowestMeldCount = melds.length;
        }
    }
    //get dead wood using the best melds
    const meldCards = [].concat(...bestMelds);
    const deadwood = handCopy.filter((c) => !meldCards.includes(c));
    //todo: split best melds into sets and runs
    const sets = [];
    const runs = [];
    for (const meld of bestMelds) {
        //if all cards are the same suit, it's a run
        const firstCard = meld[0];
        const allSameSuit = meld.every((c) => c.suit === firstCard.suit);
        if (allSameSuit) {
            runs.push(meld);
        }
        else {
            sets.push(meld);
        }
    }
    const collection = {
        sets: sets,
        runs: runs,
        deadwood: deadwood,
    };
    return collection;
}
export function getCollection2(cards) {
    //https://gist.github.com/yalue/2622575
    const collection = {
        sets: [],
        runs: [],
        deadwood: [],
    };
    const handCopy = cards.map((c) => Card.fromString(c.toString())).sort(rankAndSuitSorter);
    //find melds
    while (handCopy.length > 0) {
        const card1 = handCopy[handCopy.length - 1];
        const set = [card1];
        const run = [card1];
        for (let i = handCopy.length - 1; i >= 0; i--) {
            const card2 = handCopy[i];
            if (card1 === card2) {
                continue;
            }
            if (card1.rank === card2.rank) {
                set.push(card2);
            }
            if (card1.suit === card2.suit) {
                let nextMeldStriaghtCard = run[run.length - 1];
                const valueDiff = getRankValue(nextMeldStriaghtCard.rank) - getRankValue(card2.rank);
                if (valueDiff === 1) {
                    run.push(card2);
                }
            }
        }
        if (set.length < 3 && run.length < 3) {
            //remove card from start array
            handCopy.splice(handCopy.length - 1, 1);
            //add card to end array
            collection.deadwood.push(card1);
        }
        else {
            if (set.length > run.length) {
                //remove cards from start array
                //***not working */
                for (const setCard of set) {
                    const index = handCopy.findIndex(function (card) {
                        return card.id === setCard.id;
                    });
                    handCopy.splice(index, 1);
                }
                //add card to end array
                set.sort(rankAndSuitSorter);
                collection.sets.push(set);
            }
            else {
                //remove cards from start array
                //***not working */
                for (const runCard of run) {
                    const index = handCopy.findIndex(function (card) {
                        return card.id === runCard.id;
                    });
                    handCopy.splice(index, 1);
                }
                //add card to end array
                run.sort(rankAndSuitSorter);
                collection.runs.push(run);
            }
        }
    }
    collection.deadwood.sort(rankAndSuitSorter);
    return collection;
}
// export function getCollection(hand: Card[]): Collections {
// 	const collection: Collections = {
// 		sets: [],
// 		runs: [],
// 		deadwood: [],
// 	};
// 	const handCopy = hand.map((c) => Card.fromString(c.toString())).sort(sorter);
// 	//check for runs
// 	for (let x = 0; x < hand.length; ++x) {
// 		const card = handCopy[x];
// 		const currentRank = getRankValue(card.rank);
// 		const currentSuit = card.suit;
// 		//check for already existing run
// 		let shouldContinue = false;
// 		for (const run of collection.runs) {
// 			const firstCard = run[0];
// 			//one less than current lowest?
// 			if (currentRank + 1 === getRankValue(firstCard.rank) && currentSuit === firstCard.suit) {
// 				run.unshift(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 			const lastCard = run[run.length - 1];
// 			//one more than current highest?
// 			if (lastCard && getRankValue(lastCard.rank) + 1 === currentRank && lastCard.suit === currentSuit) {
// 				run.push(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 		}
// 		if (shouldContinue) {
// 			continue;
// 		}
// 		//Check for new run
// 		if (
// 			x < hand.length - 2 &&
// 			currentRank + 1 === getRankValue(handCopy[x + 1].rank) &&
// 			currentSuit === handCopy[x + 1].suit &&
// 			getRankValue(handCopy[x + 1].rank) + 1 === getRankValue(handCopy[x + 2].rank) &&
// 			currentSuit === handCopy[x + 2].suit
// 		) {
// 			//we have a run of card and the next two cards
// 			collection.runs.push([card, handCopy[x + 1], handCopy[x + 2]]);
// 			x += 2;
// 			continue;
// 		}
// 		//doesn't belong to any runs, let's check for sets
// 		for (const set of collection.sets) {
// 			const firstCard = set[0];
// 			if (getRankValue(firstCard.rank) === currentRank) {
// 				set.push(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 		}
// 		if (shouldContinue) {
// 			continue;
// 		}
// 		//check for new set
// 		let cardsInRuns: string[] = [];
// 		for (const run of collection.runs) {
// 			//only count "middle cards" if the run is 4+ cards
// 			if (run.length >= 4) {
// 				const runValues = run.map((c) => c.toString());
// 				runValues.pop();
// 				runValues.shift(); //take the first and last card off
// 				cardsInRuns = cardsInRuns.concat(runValues);
// 				continue;
// 			}
// 			cardsInRuns = cardsInRuns.concat(run.map((c) => c.toString()));
// 		}
// 		//need to make sure that the items in the set don't already belong to a run
// 		const filtered = handCopy.filter((c) => getRankValue(c.rank) === currentRank && !cardsInRuns.includes(c.toString()));
// 		if (filtered.length >= 3) {
// 			collection.sets.push(handCopy.filter((c) => getRankValue(c.rank) === currentRank));
// 			continue;
// 		}
// 		//doesn't belong, it's deadwood
// 		collection.deadwood.push(card);
// 	}
// 	return collection;
// }
function sorter(l, r) {
    const result = compareSuit(l.suit, r.suit);
    if (result !== 0) {
        return result;
    }
    return compareRank(l.rank, r.rank);
}
function rankAndSuitSorter(l, r) {
    const result = compareRank(l.rank, r.rank);
    if (result !== 0) {
        return result;
    }
    return compareSuit(l.suit, r.suit);
}
function orderSorter(l, r) {
    const result = l.order - r.order;
    return result;
}
//this is an in-place sort
export function sortBySuitAndRank(cards) {
    cards.sort(sorter);
    updateCardOrder(cards);
    return cards;
}
export function sortByRankAndSuit(cards) {
    cards.sort(rankAndSuitSorter);
    updateCardOrder(cards);
    return cards;
}
export function sortByMeldsRankSuit(cards) {
    const collection = getCollection(cards);
    const sets = [].concat(...collection.sets);
    const runs = [].concat(...collection.runs);
    const deadwood = [].concat(...collection.deadwood);
    deadwood.sort(rankAndSuitSorter);
    const sortedCards = [].concat(sets, runs, deadwood);
    updateCardOrder(sortedCards);
    return sortedCards;
}
export function sortByOrder(cards) {
    cards.sort(orderSorter);
    updateCardOrder(cards);
    return cards;
}
export function updateCardOrder(cards) {
    //update order
    for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        card.order = i;
    }
    return;
}
export function getTopCardOfPile(pile) {
    const pileCopy = Array.from(pile);
    pileCopy.sort((l, r) => r.order - l.order);
    return pileCopy?.[0];
}
export function getCardsInPile(cards, pile) {
    const cardPile = cards.filter((c) => c.pile === pile);
    return cardPile.sort((l, r) => l.order - r.order);
}
//Can the sent card be added to a set?
export function cardMatchesSet(card, set) {
    return card.rank === set[0].rank;
}
//Can the sent card be added to a run?
export function cardMatchesRun(card, run) {
    if (card.suit !== run[0].suit) {
        return false;
    }
    const sortedRun = sortBySuitAndRank(Array.from(run)); //ensure we're sorted to make this easier
    const sentRank = getRankValue(card.rank);
    const firstRank = getRankValue(sortedRun[0].rank);
    const lastRank = getRankValue(sortedRun[sortedRun.length - 1].rank);
    return (sentRank === (firstRank - 1)) || (sentRank === (lastRank + 1));
}
export function addCardToPile(cards, card, toFrom) {
    const oldPile = card.pile;
    //update order of "to" pile
    const pileCards = getCardsInPile(cards, toFrom);
    sortByOrder(pileCards);
    //add to pile
    card.pile = toFrom;
    card.order = pileCards.length;
    card.isSelected = false;
    //update order of "from" pile
    const fromPile = getCardsInPile(cards, oldPile);
    sortByOrder(fromPile);
}
//# sourceMappingURL=data:application/json;base64,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